import { Button } from "../buttonsLibrary";
// import { GameData } from "./gamestate/gameData";
import { Popper } from "../../Popper";
import { createMovieClip } from "../../functions/Functions_General";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { lableOutputUI } from "./btnLabels";
import { MobileFloatingButtons } from "./MobileFloatingButtons";

export class GameBar extends Popper {
  private autoPlayBtnTexture: PIXI.Texture;
  private betBtnTexture: PIXI.Texture;
  private betBtnTexture2: PIXI.Texture;
  private playBtnTextureA: PIXI.Texture;
  private playBtnTextureB: PIXI.Texture;
  private playBtnTextureP: PIXI.Texture; //place inside box icon
  private betUpBtnTexture: PIXI.Texture;
  private betDownBtnTexture: PIXI.Texture;
  private optionBtnTexture: PIXI.Texture;
  private animatedGambleBtn: PIXI.extras.AnimatedSprite;
  private playBtnIcon: PIXI.Sprite;
  private animatedPlayBtn: PIXI.extras.AnimatedSprite;
  private blackbar: PIXI.Graphics;
  private semiBlackBar: PIXI.Graphics;
  private winFrame: PIXI.Sprite;
  private balFrame: PIXI.Sprite;
  private gambleLabel: PIXI.Text;
  private collectLabel: PIXI.Text;
  private balTexts: lableOutputUI;
  private betTexts: lableOutputUI;
  private winTexts: lableOutputUI;
  private autoPlayCounts: PIXI.Text;
  private autoPlayBtnTweenSpin: PIXI.tween.Tween;
  private moveBetLabeltoRight: boolean;
  private activeGameData: CommonData;
  private size: Array<number>;
  private styleLableWhite: PIXI.TextStyle;
  private parent: PIXI.Container;
  private parent2: PIXI.Container; //for flaoting btn
  private containerBG: PIXI.Container;
  private containerBtn: PIXI.Container;

  // private playBtnContainer:PIXI.Container;

  private betBtn: Button;
  private betUpBtn: Button;
  private betDownBtn: Button;
  private optionBtn: Button;
  private gambleBtn: Button;
  private freeSpinsWinColor: PIXI.Graphics;
  private frameGradient: PIXI.Sprite;

  private mobileBtnUI: MobileFloatingButtons;
  private freeSpinsWins: PIXI.Sprite;
  private freeSpinWinsText: lableOutputUI;
  private autoPlayBtn: Button;
  private playBtn: Button;
  private playBtnIndex: number;
  private autoplayStopLabel: PIXI.Sprite;

  private desaturateMatrix: PIXI.filters.ColorMatrixFilter;
  private rootParent: PIXI.Container;

  constructor(
    parent: PIXI.Container,
    parent2: PIXI.Container,
    activeGameData: CommonData
  ) {
    super(activeGameData); //Container

    this.rootParent = parent;
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);
    // this.parent.scale.set(.1)
    // console.log(app.renderer.view.width )
    // this.parent.x=  activeGameData.app.renderer.view.width;

    this.parent2 = parent2;

    this.activeGameData = activeGameData;

    this.size = this.activeGameData.size;
    this.containerBG = new PIXI.Container(); //Scalable
    this.containerBtn = new PIXI.Container(); //Static
    //BUTTONS

    this.playBtnIndex = 0; //0-1-2-3
    //zero is for play, one is for skip, two is for collect and three is for unclickable
    this.autoPlayBtnTexture = PIXI.Texture.fromImage("btn_Autoplay.png");

    this.playBtnTextureA = PIXI.Texture.fromImage("btn_Play.png");
    this.playBtnTextureB = PIXI.Texture.fromImage("btn_Play_1.png");

    this.playBtnTextureP = PIXI.Texture.fromImage("btn_PlayPlaceDown.png");
    // this.playBtnTextureC=PIXI.Texture.fromImage('collect.png');
    // this.playBtnTextureC=PIXI.Texture.fromImage('collect.png');

    if (this.activeGameData.isMobile) {
      this.betBtnTexture = PIXI.Texture.fromImage("win_bgFrameMobile.png"); //Same PIXI.Texture reused for other UI Elemets //Off -default
      this.betBtnTexture2 = PIXI.Texture.fromImage("win_bgFrameMobile_2.png"); //Same PIXI.Texture reused for other UI Elemets //On
      this.freeSpinsWins = new PIXI.Sprite(
        PIXI.Texture.fromImage("win_bgFrameMobile.png")
      );
    } else {
      this.betBtnTexture = PIXI.Texture.fromImage("win_bgFrame.png"); //Same PIXI.Texture reused for other UI Elemets //Off -default
      this.betBtnTexture2 = PIXI.Texture.fromImage("win_bgFrame_2.png"); //Same PIXI.Texture reused for other UI Elemets //On
      this.freeSpinsWins = new PIXI.Sprite(
        PIXI.Texture.fromImage("win_bgFrame.png")
      );
    }

    this.betUpBtnTexture = PIXI.Texture.fromImage("icon_bid_up_gold.png");
    this.betDownBtnTexture = PIXI.Texture.fromImage("icon_bid_down_gold.png");
    this.optionBtnTexture = PIXI.Texture.fromImage("btn_Option.png");

    this.animatedGambleBtn = createMovieClip("gambleBTN", 0, 22); // older fixed PIXI.Texture PIXI.Texture.fromImage('gambleBTN.png');
    this.gambleBtn = new Button(
      this.animatedGambleBtn,
      new PIXI.Rectangle(-107, -35, 214, 70)
    ); // fix hitbox
    // this.gambleBtn.image.on('pointertap', this.gambleBtnClicked());
    // this.gambleBtn.image.on('pointertap', gambleClick());st)
    this.playBtnIcon = new PIXI.Sprite(this.playBtnTextureA);
    this.animatedPlayBtn = createMovieClip("btn_Play", 0, 22);
    this.animatedPlayBtn.play();
    this.animatedGambleBtn.play();
    this.blackbar;
    this.semiBlackBar;
    this.winFrame;
    this.balFrame;
    this.balTexts;
    this.betTexts;
    this.winTexts;
    this.autoPlayCounts; //Counter PIXI.Text Display over Autoplay
    this.autoPlayBtnTweenSpin;
    this.moveBetLabeltoRight = true;
    this.mobileBtnUI = new MobileFloatingButtons(
      this.parent2,
      this.activeGameData
    );

    this.activeGameData.MobileBtns = this.mobileBtnUI;

    if (this.activeGameData.isTableGame == false) {
      parent.addChild(this.containerBtn);
    }

    this.styleLableWhite = new PIXI.TextStyle({
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 35,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 35,
      stroke: "#888888",
      strokeThickness: 1,
      dropShadow: false,
      dropShadowColor: "#000000",
      dropShadowBlur: 4,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 6,
    });
    this.createFixedElem();
    this.createBG();
    this.createAutoplaySpinTween();
    this.placeBtn();
    this.setPosY();
    this.desaturateMatrix = new PIXI.filters.ColorMatrixFilter();
    let playBtnImg = this.playBtn.getImage();
    playBtnImg.filters = null; //[this.desaturateMatrix];
    // playBtnImg.filterArea=new PIXI.Rectangle(0,0,1920,1080)
    this.desaturateMatrix.desaturate();
  }

  public getParentOfPlayBtn = (): PIXI.Container | PIXI.Sprite => {
    if (this.activeGameData.isMobile == false) {
      return this.playBtn.getImage();
    } else {
      return this.mobileBtnUI.getPlayBtnSprite();
    }
  };
  public disable = (): void => {
    //--hide all the ui from game
    this.containerBtn.scale.set(0);
    this.containerBtn.alpha = 0;
    this.containerBG.scale.set(0);
    this.containerBG.alpha = 0;

    this.setbarvisible(false);
    this.mobileBtnUI.setMobileUIDisabled();
    this.setMobileUIHidden(true);
    this.parent.scale.set(0);
    this.parent.alpha = 0;

    this.rootParent.scale.set(0);
    this.rootParent.alpha = 0;

    this.optionBtn.setInteractive(false);
    this.betBtn.setInteractive(false);
    this.betBtn.setFunction(null);
  };
  private onClick = (): void => {
    this.open();
    this.close();
  };
  private createFixedElem = (): void => {
    //Create clickable
    this.playBtn = new Button(this.animatedPlayBtn, new PIXI.Circle(0, 0, 75));
    // this.playBtn.setOffScale();

    let playBtnImg = this.playBtn.getImage();
    let gambleBtnImg = this.gambleBtn.getImage();
    playBtnImg.on("pointertap", this.onClick.bind(this));
    this.autoPlayBtn = new Button(
      new PIXI.Sprite(this.autoPlayBtnTexture),
      new PIXI.Circle(0, 0, 60)
    );

    let hitbox: PIXI.Graphics = new PIXI.Graphics();
    hitbox.beginFill(0xff0000);
    hitbox.alpha = 0.5;
    hitbox.drawCircle(0, 0, 60);
    hitbox.endFill();

    // this.autoPlayBtn.image.addChild(hitbox)
    this.optionBtn = new Button(
      new PIXI.Sprite(this.optionBtnTexture),
      new PIXI.Circle(0, 0, 75)
    );
    if (this.activeGameData.isMobile) {
      this.betBtn = new Button(
        new PIXI.Sprite(this.betBtnTexture),
        new PIXI.Rectangle(-533 / 2, -117 / 2 - 70, 533, 117 + 70)
      );
      // this.betBtn= new Button (new PIXI.Sprite(this.betBtnTexture),new PIXI.Rectangle(-533/2, -117/2,533, 117),this.activeGameData);

      // this.betBtn.image.addChild(hitbox)
    } else {
      this.betBtn = new Button(
        new PIXI.Sprite(this.betBtnTexture),
        new PIXI.Rectangle(-130, -48.5, 350, 97)
      );
    }

    this.betUpBtn = new Button(
      new PIXI.Sprite(this.betUpBtnTexture),
      new PIXI.Rectangle(-42, -24, 85, 45)
    );
    // this.betBtn.setOffScale();
    this.betDownBtn = new Button(
      new PIXI.Sprite(this.betDownBtnTexture),
      new PIXI.Rectangle(-42, -20, 85, 45)
    );

    this.winFrame = new PIXI.Sprite(this.betBtnTexture);
    this.balFrame = new PIXI.Sprite(this.betBtnTexture);
    this.autoPlayCounts = new PIXI.Text("x" + 0, {
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontWeight: "bold",
      fontSize: 30,
      fill: "white",
      align: "center",
      stroke: "black",
      strokeThickness: 5,
    });

    this.autoplayStopLabel = new PIXI.Sprite(
      PIXI.Texture.fromFrame("btn_stop.png")
    );
    this.blackbar = new PIXI.Graphics();
    // this.blackbar.beginFill(0x000000);
    this.blackbar.drawRect(0, 0, this.size[0], 5);
    this.blackbar.endFill();
    this.blackbar.alpha = 1;

    //----------------------------
    //setup label on gamble and collect

    this.gambleLabel = new PIXI.Text(
      this.activeGameData.gameTextGeneral.gamble,
      this.styleLableWhite
    );
    this.gambleLabel.anchor.set(0.5);
    if (this.gambleLabel.width > this.gambleBtn.getWidth() - 30) {
      this.gambleLabel.width = this.gambleBtn.getWidth() - 30;
    }
    this.collectLabel = new PIXI.Text(
      this.activeGameData.gameTextGeneral.collect,
      this.styleLableWhite
    );
    this.collectLabel.anchor.set(0.5);
    // this.collectLabel.height=this.playBtn.image.width-this.collectLabel.width;

    if (this.collectLabel.width > this.playBtn.getWidth() - 30) {
      this.collectLabel.width = this.playBtn.getWidth() - 30;
    }

    // let playBtnImg=this.playBtn.getImage();
    playBtnImg.addChild(this.collectLabel);
    gambleBtnImg.addChild(this.gambleLabel);
    this.collectLabel.alpha = 0;
  };
  private createBG = (): void => {
    this.semiBlackBar = new PIXI.Graphics();
    this.semiBlackBar.beginFill(0xff0000);
    this.semiBlackBar.drawRect(0, 0, this.size[0], 37);
    this.semiBlackBar.endFill();
    this.semiBlackBar.alpha = 0;
    this.containerBG.addChild(this.semiBlackBar);
  };
  private createAutoplaySpinTween = (): void => {
    let autoPlayImg = this.autoPlayBtn.getImage();
    this.autoPlayBtnTweenSpin = PIXI.tweenManager.createTween(autoPlayImg);
    this.autoPlayBtnTweenSpin
      .from({ rotation: autoPlayImg.rotation })
      .to({ rotation: autoPlayImg.rotation + ((360 * Math.PI) / 180) * -1 });
    this.autoPlayBtnTweenSpin.time = 3000;
    this.autoPlayBtnTweenSpin.easing = PIXI.tween.Easing.linear();
    this.autoPlayBtnTweenSpin.loop = true;
    this.autoPlayBtnTweenSpin.stop();
  };
  private startAutoPlayTween = (spin: boolean): void => {
    if (spin) {
      this.autoPlayBtnTweenSpin.start();
      this.autoPlayBtn.getImage().texture = PIXI.Texture.fromFrame(
        "btn_AutoplayActive.png"
      );

      if (
        this.activeGameData.betResponse.gameContext.contextData
          .bonusGameResult != undefined ||
        this.activeGameData.betResponse.gameContext.contextData.bonus
      ) {
        this.autoplayStopLabel.alpha = 0;
      } else {
        this.autoplayStopLabel.alpha = 1;
      }
    } else {
      this.autoPlayBtnTweenSpin.stop();
      this.autoPlayBtnTweenSpin.reset();
      this.autoPlayBtn.getImage().texture = PIXI.Texture.fromFrame(
        "btn_Autoplay.png"
      );
      this.autoplayStopLabel.alpha = 0;
    }
  };
  private setPosY = (): void => {
    this.containerBtn.y =
      this.activeGameData.size[1] - this.containerBtn.height / 2 - 10; //POSITON OF BAR
    if (this.activeGameData.isMobile) {
      this.containerBtn.y =
        this.activeGameData.size[1] - this.containerBtn.height + 10; //POSITON OF BAR
    }
  };

  public removeFromCanvas() {
    //
    // this.mobileBtnUI.removeFromCanvas();
  }

  public setGambleButtonActive = (bool: boolean): void => {
    let alphaValue: number = 1;
    if (bool === false) {
      alphaValue = 0;
    }

    if (this.activeGameData.isMobile === false) {
      // this.gambleBtn.setInteractive(bool);
      this.gambleBtn.setAlpha(alphaValue);
      // this.mobileBtnUI.setGambleMode(false);

      if (this.activeGameData.replayMode) {
        this.gambleBtn.setInteractive(false);
      } else {
        this.gambleBtn.setInteractive(bool);
      }
      this.mobileBtnUI.setGambleMode(false);

      //
    } else {
      this.gambleBtn.setAlpha(0);
      if (this.activeGameData.replayMode) {
        // this.mobileBtnUI.setGambleMode(false);
        if (bool) {
          //if gamble should be visibile
          this.mobileBtnUI.setVisibleOnlyGamble();
        } else {
          this.mobileBtnUI.setGambleMode(false);
        }
      } else {
        this.mobileBtnUI.setGambleMode(bool);
      }

      this.gambleBtn.setInteractive(false);
    }
    // console.log(alphaValue)
  };

  public setGambleBtnsButtonMode = (bool: boolean): void => {
    this.mobileBtnUI.setGambleButtonMode(bool);
    this.gambleBtn.setInteractive(bool);
  };

  private mobileLayout = (): void => {
    //hide pc elememts
    this.optionBtn.placeButton(this.containerBtn, [
      125,
      this.optionBtn.getHeight() / 2 + 20,
    ]);
    this.betBtn.placeButton(this.containerBtn, [
      400 + this.balFrame.width + 50 + 35 / 2,
      this.betBtn.getHeight() / 2 - 5,
    ]);
    // this.containerBG.addChild(this.blackbar);

    this.containerBtn.addChild(this.winFrame);
    this.containerBtn.addChild(this.balFrame);
    this.winFrame.position.set(
      400 + this.balFrame.width * 2 + 100,
      this.winFrame.height / 2 - 5
    );
    this.balFrame.position.set(400 + 35, this.balFrame.height / 2 - 5);
    this.containerBtn.y = this.size[1] - this.containerBtn.height; //POSITON OF BAR
    this.containerBG.y = 0; //POSITON OF BAR
    this.blackbar.height = 40;
    // this.semiBlackBar.height=130;
    this.blackbar.y = this.semiBlackBar.height;
    this.semiBlackBar.y = 0;
  };
  private pcLayout = (): void => {
    let playBtnImg = this.playBtn.getImage();
    // this.containerBtn.addChild(playBtnImg);
    playBtnImg.addChild(this.playBtnIcon);
    // this.parent
    //     let ss= createMovieClip("btn_Play", 0, 22);
    //   let  nimatedPlayBtn =  new Button( ss, new PIXI.Circle(0, 0, 75));;
    //   this.containerBtn.addChild(nimatedPlayBtn.getImage());
    //   nimatedPlayBtn.placeButton(this.parent,[this.size[0] - 290 + 25, this.size[1] - 105]);
    this.playBtn.placeButton(this.parent, [
      this.size[0] - 290 + 25,
      this.size[1] - 105 - 20,
    ]);
    this.playBtn.setScale(1.4);
    if (this.activeGameData.enableAutoPlayButton) {
      this.autoPlayBtn.placeButton(this.containerBtn, [
        this.size[0] - 100 - 25,
        0,
      ]);
      this.containerBtn.addChild(this.autoPlayCounts);
    }

    this.mobileBtnUI.setMobileUIDisabled();

    this.optionBtn.placeButton(this.containerBtn, [100 + 30, 0]);
    this.betBtn.placeButton(this.containerBtn, [
      400 + this.balFrame.width + 10,
      5,
    ]);
    // this.containerBG.addChild(this.blackbar);
    let btn = this.betBtn.getImage();
    this.betUpBtn.placeButton(this.containerBtn, [
      btn.x - btn.width / 2 + 50,
      btn.y - btn.height / 2 + 20,
    ]);
    this.betDownBtn.placeButton(this.containerBtn, [
      btn.x - btn.width / 2 + 50,
      btn.y + btn.height / 2 + 2 - 20 - 15,
    ]);
    // this.betUpBtn.placeButton(this.containerBtn, this.betBtn.getPosX() - this.betBtn.getWidth() / 2 + 50, this.betBtn.getPosY() - this.betBtn.getHeight() / 2 + 20);
    // this.betDownBtn.placeButton(this.containerBtn, this.betBtn.getPosX() - this.betBtn.getWidth()/ 2 + 50, this.betBtn.getPosY() + this.betBtn.getHeight()/ 2 + 2 - 20);

    this.containerBtn.addChild(this.winFrame);
    this.containerBtn.addChild(this.balFrame);
    this.winFrame.position.set(400 + this.balFrame.width * 2 + 20, 5);
    this.balFrame.position.set(400, 5);

    // this.containerBtn.y=(this.size[1])//-this.containerBtn.height)-20;//POSITON OF BAR
    this.containerBG.y = 0; //POSITON OF BAR
    this.blackbar.height = 40;
    this.semiBlackBar.height = 130;
    this.blackbar.y = this.semiBlackBar.height;
    this.semiBlackBar.y = 0;

    this.autoPlayCounts.x =
      this.autoPlayBtn.getPosX() - this.autoPlayCounts.width / 2;
    this.autoPlayCounts.y =
      this.autoPlayBtn.getPosY() - this.autoPlayCounts.height / 2;

    this.autoplayStopLabel.anchor.set(0.5);
    this.autoplayStopLabel.x = this.autoPlayBtn.getPosX(); // - this.autoPlayCounts.width / 2;;
    this.autoplayStopLabel.y =
      this.autoPlayBtn.getPosY() + this.autoPlayCounts.height; //- this.autoPlayCounts.height / 2;
    this.containerBtn.addChild(this.autoplayStopLabel);
    this.autoplayStopLabel.alpha = 0;

    // let h=new PIXI.Graphics();
    // h.beginFill(0xff0000);
    // h.drawRect(-0/2,0,this.containerBtn.width,  this.containerBtn.height);
    // h.alpha=.5
    // h.endFill();
    // this.parent.addChild(h)
    // console.log(this.parent.alpha)
  };

  public setBlackAndWhitePlay = (): void => {
    this.playBtn.getImage().filters = [this.desaturateMatrix];
    this.mobileBtnUI.setBlackAndWhitePlay();
  };

  public setPlayButtonIndex = (playTexNum: number): void => {
    this.playBtn.getImage().filters = null;
    switch (playTexNum) {
      case 0: //playMode
        this.playBtnIcon.texture = this.playBtnTextureA;
        this.playBtnIcon.x = 5;
        this.playBtnIcon.alpha = 1;
        this.collectLabel.alpha = 0;
        this.mobileBtnUI.setplayBtnMode(0);
        this.playBtnIndex = 0;
        break;
      case 1: //skip
        // let isBonusGame=  (this.activeGameData.betResponse.gameContext.contextData.bonusGameResult!=undefined || this.activeGameData.betResponse.gameContext.contextData.bonus)

        if (this.activeGameData.commonConfigData.isSkipAvailable) {
          this.playBtnIcon.texture = this.playBtnTextureB;
          this.playBtnIcon.x = 0;
          this.playBtnIcon.alpha = 1;
          this.collectLabel.alpha = 0;
          this.mobileBtnUI.setplayBtnMode(1);
          this.playBtnIndex = 0;
        } else {
          this.setBlackAndWhitePlay();
        }

        break;
      case 2: //collect
        this.playBtnIcon.texture = this.playBtnTextureA;
        this.playBtnIcon.alpha = 0;
        this.collectLabel.alpha = 1;
        this.playBtnIcon.x = 0;
        this.mobileBtnUI.setplayBtnMode(2);
        this.playBtnIndex = 2;
        break;

      case 3: //_a null case that does nothing act as place holder while collecting
        this.playBtnIcon.texture = this.playBtnTextureA;
        this.playBtnIcon.alpha = 0;
        this.collectLabel.alpha = 1;
        this.playBtnIcon.x = 0;
        this.mobileBtnUI.setplayBtnMode(2);
        this.playBtnIndex = 4;
        break;

      case 4: ////---used for  dice games like star dice
        this.playBtnIcon.texture = this.playBtnTextureP;
        this.playBtnIcon.x = 0;
        this.playBtnIcon.alpha = 1;
        this.collectLabel.alpha = 0;
        this.mobileBtnUI.setplayBtnMode(0);
        this.playBtnIndex = 0;
        break;
    }
  };

  public getplayBtnIndex = (): number => {
    // console.log(this.animatedPlayBtn.position)
    // let test=new PIXI.Graphics();
    // this.containerBtn.addChild()
    return this.playBtnIndex;
  };

  public getPlayButtonMode = (): boolean => {
    return this.playBtn.getButtonMode();
  };
  public getParent = (): PIXI.Container => {
    return this.parent2;
  };

  public setMobilePlayBtnTexture = (texturenames: Array<string>): void => {
    // ['play','skip','collect']
    this.mobileBtnUI.setNewTexturePlayBtn(texturenames, this.playBtnIndex);
  };

  private placeBtn = (): void => {
    this.playBtnIcon.anchor.set(0.5);
    this.playBtnIcon.x = 5;
    this.winFrame.anchor.set(0.5);
    this.balFrame.anchor.set(0.5);
    this.gambleBtn.placeButton(this.winFrame, [
      this.winFrame.width / 2 - this.gambleBtn.getWidth() / 2,
      -this.gambleBtn.getHeight() / 2,
    ]);
    this.setGambleButtonActive(false);

    this.balTexts = new lableOutputUI(
      this.balFrame,
      this.activeGameData.gameTextGeneral.bal,
      this.activeGameData
    );
    this.betTexts = new lableOutputUI(
      this.betBtn.getImage(),
      this.activeGameData.gameTextGeneral.bet,
      this.activeGameData
    );
    this.winTexts = new lableOutputUI(
      this.winFrame,
      this.activeGameData.gameTextGeneral.win,
      this.activeGameData
    );
    if (this.activeGameData.isMobile != true) {
      this.betTexts.setPositionOffset(this.moveBetLabeltoRight);
    }

    if (this.activeGameData.isMobile == false) {
      this.pcLayout();
    } else {
      this.mobileLayout();
    }

    //freeSpins
    this.freeSpinsWinColor = new PIXI.Graphics();
    this.freeSpinsWinColor.beginFill(0x379408);
    this.freeSpinsWinColor.drawRoundedRect(
      0,
      0,
      this.freeSpinsWins.width - 4,
      this.freeSpinsWins.height,
      10
    );
    this.freeSpinsWinColor.endFill();
    this.freeSpinsWinColor.alpha = 1;
    this.freeSpinsWinColor.x = -this.freeSpinsWinColor.width / 2;
    this.freeSpinsWinColor.y = -this.freeSpinsWinColor.height / 2;
    this.freeSpinsWins.addChild(this.freeSpinsWinColor);

    this.frameGradient = new PIXI.Sprite(PIXI.Texture.fromFrame("green.png"));
    this.frameGradient.rotation = Math.PI;
    this.frameGradient.anchor.set(0.5);
    this.frameGradient.y = -10;
    this.frameGradient.width = this.freeSpinsWinColor.width;
    this.frameGradient.height = this.freeSpinsWinColor.height;
    this.freeSpinsWins.addChild(this.frameGradient);

    this.freeSpinWinsText = new lableOutputUI(
      this.freeSpinsWins,
      this.activeGameData.gameTextGeneral.fs,
      this.activeGameData
    );
    // this.freeSpinWinsText.currency.text = this.freeSpinWinsText.label.text;
    this.freeSpinWinsText.setCurrencyText(
      this.freeSpinWinsText.getLabel().text
    );
    this.freeSpinWinsText.setlabelText(
      this.activeGameData.gameTextGeneral.winnings
    );
    this.freeSpinsWins.anchor.set(0.5);
    this.balFrame.addChild(this.freeSpinsWins);
    this.freeSpinWinsText.setValue("0.00");
    this.freeSpinsWins.alpha = 0;
    this.freeSpinsWins.height = this.winFrame.height;

    this.freeSpinsWins.y += 10;

    // mobile
    if (this.activeGameData.isMobile == true) {
      this.freeSpinWinsText.setCurrencyPosX(555); //currency.x = 555
      this.freeSpinWinsText.setOutputAlpha(1); //.outPut.alpha = 1;
      this.freeSpinWinsText.setFontSize(35);
    }
  };

  public setFreeSpinUI = (bool: boolean): void => {
    let i = bool ? 1 : 0;
    this.freeSpinsWins.alpha = i;
    if (bool == false) {
      this.setFreeSpinWinValue("0");
    }
  };

  public setFreeSpinWinValue = (value: string): void => {
    this.freeSpinWinsText.setValue(value);
  };
  // placeTo(parent:PIXI.Container)
  // {
  //     parent.addChild(this.containerBtn)

  // }
  //Individually change the output display value
  public setBetValue = (value: number | string): void => {
    this.betTexts.setValue(value.toString());
    if (this.activeGameData.isMobile) {
      this.activeGameData.mobilePortraitUI.setBetValue(value.toString());
    }
  };
  public setWinValue = (value: number | string): void => {
    // console.log("set WIN ", value);

    if (typeof value === "number") {
      value = value.toFixed(2);
    }
    this.winTexts.setValue(value.toString());

    if (this.activeGameData.isMobile) {
      this.activeGameData.mobilePortraitUI.setWinValue(value.toString());
    }
  };
  public setBalValue = (value: number | string): void => {
    this.balTexts.setValue(value.toString());

    if (this.activeGameData.isMobile) {
      this.activeGameData.mobilePortraitUI.setBalValue(value.toString());
    }
    // console.log("edit",value)
  };
  public setBetBtnFunction = (fn: Function): void => {
    this.betBtn.setFunction(fn);

    if (this.activeGameData.playOnPortrait && this.activeGameData.isMobile) {
      this.activeGameData.mobilePortraitUI.setBetFn(fn);
    }
  };
  public setPlayBtnFunction = (fn: Function): void => {
    this.playBtn.setFunction(fn);
    this.mobileBtnUI.setPlayfn(fn);
  };
  public setOptionBtnFunction = (fn: Function): void => {
    this.optionBtn.setFunction(fn);
    // if()

    if (
      this.activeGameData.playOnPortrait &&
      this.activeGameData.isMobile &&
      this.activeGameData.mobilePortraitUI != undefined
    ) {
      this.activeGameData.mobilePortraitUI.setoptionFn(fn);
    }
  };

  public setAutoplayBtnFunction = (fn: Function): void => {
    this.autoPlayBtn.setFunction(fn);
    this.mobileBtnUI.setAutoFn(fn);
    // console.log("changed")
  };
  public setBetUpBtnFunction = (fn: Function): void => {
    this.betUpBtn.setFunction(fn.bind(undefined, "up", this.activeGameData));
  };
  public setBetDownBtnFunction = (fn: Function): void => {
    this.betDownBtn.setFunction(
      fn.bind(undefined, "down", this.activeGameData)
    );
  };
  public setGambleBtnFunction = (fn: Function): void => {
    // this.gambleBtn.image.on('pointertap', fn.bind(undefined, this.activeGameData));
    this.gambleBtn.setFunction(fn.bind(undefined, this.activeGameData));
    this.mobileBtnUI.setGambleFn(fn);
  };

  public setAutoPlayCount = (newAutoPlayCounter: number): void => {
    this.autoPlayCounts.text = "x" + newAutoPlayCounter;
    this.autoPlayCounts.x =
      this.autoPlayBtn.getPosX() - this.autoPlayCounts.width / 2;
    // console.log((this.autoPlayCounts.text),this.autoPlayBtnTweenSpin.active)
    // if(parseInt(newAutoPlayCounter)>0 && this.autoPlayBtnTweenSpin.active==false)

    this.mobileBtnUI.setAutoplayCount(newAutoPlayCounter);

    if (newAutoPlayCounter > 0 && this.autoPlayBtnTweenSpin.active == false) {
      if (this.activeGameData.isMobile) {
        this.mobileBtnUI.setAutoplayRotationTween(true);
      } else {
        this.startAutoPlayTween(true);
      }

      // console.log("startspin");
    } else if (newAutoPlayCounter === 0) {
      this.startAutoPlayTween(false);

      this.mobileBtnUI.setAutoplayRotationTween(false);
      // console.log("stopspin");
    }

    //startSpinTween
  };

  public setBetButtonClickable = (bool: boolean): void => {
    // console.log("STACKE CAN BE CHANGED", bool)

    if (bool) {
      this.betBtn.setNewTexture(this.betBtnTexture2); //
    } else {
      this.betBtn.setNewTexture(this.betBtnTexture);
    }
    if (this.activeGameData.isGame) {
      this.betBtn.setInteractive(bool);
      this.betUpBtn.setInteractive(bool);
      this.betDownBtn.setInteractive(bool);
    }
    let i = bool ? 1 : 0;
    this.betUpBtn.setAlpha(i);
    this.betDownBtn.setAlpha(i);

    //--make it also applied to the portrait
    if (this.activeGameData.mobilePortraitUI != undefined) {
      this.activeGameData.mobilePortraitUI.setInteractive(bool);
    }
  };
  public setAutoPlayBtn = (bool: boolean): void => {
    if (
      this.activeGameData.betResponse.gameContext.contextData.bonus !=
        undefined &&
      this.activeGameData.betResponse.gameContext.contextData.bonus == true
    ) {
      bool = false;
    }
    this.autoPlayBtn.getImage().tint = bool ? 0xffffff : 0x333333;
    //-
    this.autoPlayBtn.setInteractive(bool);
    this.mobileBtnUI.getAutoplayBtn().getImage().tint = bool
      ? 0xffffff
      : 0x333333;
    this.mobileBtnUI.getAutoplayBtn().setInteractive(bool);
  };
  public getGameBarHeight = (): number => {
    return this.containerBG.height;
  };

  public setButtonMode = (bool: boolean): void => {
    this.optionBtn.setInteractive(bool);

    this.autoPlayBtn.setInteractive(bool);

    this.playBtn.setInteractive(bool);

    this.mobileBtnUI.setButtonMode(bool);

    //-------------portraitMode
    if (this.activeGameData.playOnPortrait && this.activeGameData.isMobile) {
      this.activeGameData.mobilePortraitUI.setInteractive(bool);
      // console.log('setInteractive',bool)
    }
  };

  public setMobileUIHidden = (bool: boolean): void => {
    this.mobileBtnUI.setHidden(bool);
  };

  public getContainerHeight = (): number => {
    return this.containerBG.height;
  };

  public getMobileContainer = (): PIXI.Container => {
    return this.mobileBtnUI.getParentContainer();
  };

  public setMobileBtnPosX = (posX: number): void => {
    this.parent2.x = posX;
    // console.log(this.parent2.x);
    // this.parent2.x=this.parent2.x/2;
  };

  public setMobileBtnPosY = (posY: number): void => {
    this.parent2.y = posY;
    // console.log(this.parent2.x);
    // this.parent2.x=this.parent2.x/2;
  };

  public setPortraitPlay = (): void => {
    this.mobileBtnUI.setPortraitMode();
  };

  public getMobileWidth = (): number => {
    return this.mobileBtnUI.getPlayButtonWidth();
  };

  public setbarvisible = (bool: boolean) => {
    if (bool) {
      this.containerBtn.alpha = 1;
      this.containerBtn.scale.set(1);
    } else {
      this.containerBtn.alpha = 0;
      this.containerBtn.scale.set(0);
    }
  };
  public hidePlayOnPortrait = (bool: boolean): void => {
    this.mobileBtnUI.onAutoplayOpenHidePlayBtnOnPortraitMode(bool);
  };
  public removePlaybtn = (): void => {
    this.playBtn.getImage().destroy();
  };
}
